import purchase from './purchase';
import payment from './payment';
import confirmation from './confirmation';
import completion from './completion';
import common from './common'

export default {
  purchase,
  payment,
  confirmation,
  completion,
  common,
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/index.js